const localStorageUserKey = `${window.location.hostname}_81handyman_user`;
const localStorageAdminKey = `${window.location.hostname}_81handyman_admin`;

export {localStorageUserKey, localStorageAdminKey};
